<template>
  <base-form
    v-model="data"
    :options="options"
    :disabled="this.contractStatusList.indexOf(data.contractStatus) != -1 ? false : disabled"
    :rules="rules"
    labelWidth="95px"
    @input="handleChange"
    ref="baseForm"
  ></base-form>
</template>

<script>
  import { mapState } from 'vuex';
  import baseForm from '@/components/form/base-form';
  import AGENCY_API from '@/api/agencyContract/index';
  // import COMPANY_API from '@/api/masterData/company';
  import { calAmount } from '@/common/js/contract-cal';
  import { spliceMoreZero } from '@/common/js/util';
  import { getLocalDataProps } from '../js';
  import BASE_API from '@/api/dataBase.js';
  import { dateFormatter } from '@/common/js/util';

  export default {
    props: {
      defaultData: {
        type: Object,
        default: () => {},
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      // 合同状态
      contractStatus: {
        type: String,
        default: () => '',
      },
      initFlag: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      baseForm,
    },
    data() {
      var validateCustomer = (rule, value, callback) => {
        // 校验客户
        if (this.data.customer === '' && this.isHaveTo) {
          callback(new Error('contractAgency.validateCustomer'));
        } else {
          callback();
        }
      };
      var validateSupplier = (rule, value, callback) => {
        // 校验供应商
        if (this.data.supplier === '' && this.supplierTo) {
          callback(new Error('contractAgency.validateSupplier'));
        } else {
          callback();
        }
      };
      //  代理费  保证金   销售费用   采购费用
      const amountProps = ['proxyExpense', 'marginAmount', 'salesExpense']; //销售相关汇率用销售汇率  salesCurrencyExchangeRate
      const purAmountProps = ['purchaseExpense']; //采购相关汇率用采购汇率  contractCurrencyExchangeRate
      const localProps = getLocalDataProps(amountProps);
      const purlocalProps = getLocalDataProps(purAmountProps);
      return {
        // options:[],
        data: {
          settleCurrency: '1', // 结算货币类型：默认销售货币
          contractCurrencyExchangeRate: 1, // 采购汇率：根据货币类型从后端获取
          salesCurrencyExchangeRate: 1, // 销售汇率：根据货币类型从后端获取
          salesCurrencyCode: '',
          salesCurrencyName: '',
          purchaseCurrencyCode: '',
          purchaseCurrencyName: '',
          capitalOccupancyRate: 0, //资金占用率
          proxyExpenseLocal: 0, //代理费
          marginPercentage: 0, //保证金比率
          marginAmount: 0, //保证金
          ...localProps,
          ...purlocalProps,
          // partnerType:{partnerType:''},
          flag: false, //标记短装比例
          contractDepartmentList: [],
        },
        contractStatusList: ['ZT061', 'ZT051'], // 草稿、已驳回 ,修订中，修改已驳回 可以修改"
        rules: {
          customer: [{ validator: validateCustomer, trigger: 'blur' }],
          supplier: [{ validator: validateSupplier, trigger: 'blur' }],
        },
        amountProps,
        purAmountProps,
      };
    },
    computed: {
      isHaveTo: function () {
        return this.data.proxyType !== `DLXS01`; // 代理形式不为采购代理，客户必填
      },
      supplierTo: function () {
        return this.data.proxyType !== `DLXS02`; // 代理形式不为代理销售，供应商必填
      },

      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      options() {
        const data = this.data;
        return [
          // 合同编号
          {
            type: 'input',
            label: this.$t('contractAgency.contractNo'),
            prop: 'contractNo',
            disabled: true,
          },
          {
            //贸易类型
            type: 'ajaxSelect',
            label: this.$t('contractAgency.tradeType'),
            prop: 'tradeType',
            apiUrl: AGENCY_API.DICT_LIST,
            apiData: { dictType: 'proxy_trade_type' },
            required: true,
            valueType: 'string',
            disabled:
              this.contractStatusList.indexOf(data.contractStatus) != -1 ? true : this.disabled,
          },
          {
            //业务性质
            type: 'ajaxSelect',
            label: this.$t('contractAgency.businessNature'),
            prop: 'businessType',
            apiUrl: AGENCY_API.DICT_LIST,
            apiData: { dictType: 'proxy_business_type' },
            required: true,
            valueType: 'string',
            disabled:
              this.contractStatusList.indexOf(data.contractStatus) != -1 ? true : this.disabled,
          },
          //制单日期
          {
            type: 'date',
            label: this.$t('contractAgency.orderMakeTime'),
            prop: 'contractCreateDate',
            disabled: true,
            required: true,
          },
          //操作人
          {
            type: 'input',
            label: this.$t('contractAgency.oprateMan'),
            prop: 'contractOperaterName',
            disabled: true,
            required: true,
          },
          {
            // 业务员可修改
            type: 'searchTable',
            label: this.$t('contractAgency.saleMan'),
            prop: 'contractSalesmanNo',
            searchType: 'personnel',
            isMultiple: true,
            name: 'contractSalesmanName',
            code: 'contractSalesmanNo',
            getName: 'personName',
            getCode: 'id',
          },
          {
            // 业务部门
            type: 'ajaxSelect',
            label: this.$t('contractAgency.businessDepartment'),
            prop: 'contractDepartmentNo',
            apiUrl: BASE_API.GET_PERSON_API,
            apiData: {
              id: this.userInfo.userInfo.userCode,
              userCode: this.userInfo.userInfo.userCode,
              personName: this.userInfo.userInfo.userName,
              personCompanyCode: this.data.contractCompanyNo,
            },
            dataString: 'data.personDepartmentInfo',
            valueKey: 'personDepartmentCode',
            labelKey: 'personDepartmentName',
            name: 'contractDepartmentName',
            code: 'contractDepartmentNo',
            valueType: '',
            disabled:
              this.contractStatusList.indexOf(data.contractStatus) != -1 ? true : this.disabled,
          },
          {
            //委托方
            type: 'searchTable',
            prop: 'entrustingPart',
            label: this.$t('contractAgency.clientName'),
            searchType: 'customer',
            required: true,
            isMultiple: true,
            name: 'entrustingPartName',
            code: 'entrustingPartNo',
            getName: 'partnerZhName',
            getCode: 'partnerCode',
            original: 'entrustingPartList',
            extraData: {
              partnerTypes: 'HZHB03,HZHB02,HZHB01', //合作伙伴，供应商，客户
              departmentCode: this.data.contractDepartmentNo, //部门
              companyCode: this.data.contractCompanyNo, //公司
            },
            disabled:
              this.contractStatusList.indexOf(data.contractStatus) != -1 ? true : this.disabled,
          },
          {
            //供应商
            type: 'searchTable',
            prop: 'partner',
            isMultiple: true,
            label: this.$t('contractAgency.supplier'),
            searchType: 'supplier',
            required: this.supplierTo, // 供应商
            name: 'partnerName',
            code: 'partnerNo',
            getName: 'partnerZhName',
            getCode: 'partnerCode',
            original: 'partnerList',
            extraData: {
              partnerTypes: 'HZHB02,HZHB03', //供应商，合作伙伴
              departmentCode: this.data.contractDepartmentNo, //部门
              companyCode: this.data.contractCompanyNo, //公司
            },
            disabled:
              this.contractStatusList.indexOf(data.contractStatus) != -1 ? true : this.disabled,
          },
          {
            //客户
            type: 'searchTable',
            prop: 'customer',
            isMultiple: true,
            label: this.$t('contractAgency.customer'),
            searchType: 'customer',
            required: this.isHaveTo, // 客户
            name: 'customerName',
            code: 'customerNo',
            getName: 'partnerZhName',
            getCode: 'partnerCode',
            original: 'customerList',
            extraData: {
              partnerTypes: 'HZHB01,HZHB03', //客户，合作伙伴
              departmentCode: this.data.contractDepartmentNo, //部门
              companyCode: this.data.contractCompanyNo, //公司
            },
            disabled:
              this.contractStatusList.indexOf(data.contractStatus) != -1 ? true : this.disabled,
          },
          {
            // 公司
            type: 'input',
            label: this.$t('contractAgency.company'),
            prop: 'contractCompanyName',
            disabled: true,
            required: true,
          },
          {
            //结算货币
            label: this.$t('contractAgency.settlement'),
            type: 'select',
            prop: 'settleCurrency',
            options: [
              { value: '1', label: this.$t('contractAgency.salesCurrency') }, //销售
              { value: '2', label: this.$t('contractAgency.purchaseCurrency') }, //采购
            ],
          },
          {
            // 外部合同号 (采购端)
            type: 'input',
            label: this.$t('contractAgency.purchaseExternalContractNo'),
            prop: 'purchaseExternalContractNo',
            required: true,
            maxlength: 32,
          },
          {
            //采购付款方式
            type: 'ajaxSelect',
            label: this.$t('contractAgency.purchasePayMethod'),
            prop: 'purchasePayMethod',
            apiUrl: BASE_API.DIC_CREDIT_API,
            apiData: { dictType: 'payment_method' },
            required: true,
            valueType: 'string',
          },
          {
            // 采购货币：选择
            type: 'ajaxSelect',
            label: this.$t('contractAgency.purchaseCurrency'),
            prop: 'purchaseCurrencyCode',
            apiUrl: AGENCY_API.LIST_CURRENCY,
            method: 'get',
            apiData: { isEnabled: 1 },
            required: true,
            name: 'purchaseCurrencyName',
            code: 'purchaseCurrencyCode',
            valueKey: 'currencyCode',
            moreShowKey: 'currencyCode',
            labelKey: 'currencyName',
            valueType: 'object',
            isFocus: false,
          },
          {
            //汇率   采购汇率
            type: 'input',
            prop: 'contractCurrencyExchangeRate',
            disabled: true,
            required: true,
            label: this.$t('contractAgency.contractCurrencyExchangeRate'), // 汇率
            placeholder: this.$t('contractAgency.contractCurrencyExchangeRate'),
          },
          {
            //采购费用
            type: 'amountNumber',
            label: this.$t('contractAgency.purchaseExpense'),
            prop: 'purchaseExpense',
            moreInput: true,
            moreProp: 'purchaseExpenseLocal',
            moreDisabled: true,
          },
          {
            //外部合同号 (代理端)
            type: 'input',
            label: this.$t('contractAgency.salesExternalContractNo'),
            prop: 'salesExternalContractNo',
            required: true,
            maxlength: 32,
          },
          {
            //销售付款方式
            type: 'ajaxSelect',
            label: this.$t('contractAgency.salesPayMethod'),
            prop: 'salesPayMethod',
            apiUrl: BASE_API.DIC_CREDIT_API,
            apiData: { dictType: 'payment_method' },
            required: true,
            valueType: 'string',
          },
          {
            // 销售货币：选择
            type: 'ajaxSelect',
            label: this.$t('contractAgency.salesCurrency'),
            prop: 'salesCurrencyCode',
            apiUrl: AGENCY_API.LIST_CURRENCY,
            method: 'get',
            apiData: { isEnabled: 1 },
            required: true,
            name: 'salesCurrencyName',
            code: 'salesCurrencyCode',
            valueKey: 'currencyCode',
            moreShowKey: 'currencyCode',
            labelKey: 'currencyName',
            valueType: 'object',
            isFocus: false,
          },
          {
            //汇率   销售汇率
            type: 'input',
            prop: 'salesCurrencyExchangeRate',
            disabled: true,
            required: true,
            label: this.$t('contractAgency.salesCurrencyExchangeRate'), // 汇率
            placeholder: this.$t('contractAgency.rateMessage'),
          },
          {
            //销售费用
            type: 'amountNumber',
            label: this.$t('contractAgency.salesExpense'),
            prop: 'salesExpense',
            moreInput: true,
            moreProp: 'salesExpenseLocal',
            moreDisabled: true,
            placeholder:
              this.$t('contractAgency.inputTip') + this.$t('contractAgency.salesExpense'),
          },
          {
            //资金占用利率
            type: 'amountNumber',
            label: this.$t('contractAgency.capitalOccupancyRate'),
            prop: 'capitalOccupancyRate',
            append: '%',
            max: 100,
            precision: this.$globalVar.iPoint,
            required: true,
            placeholder:
              this.$t('contractAgency.inputTip') + this.$t('contractAgency.capitalOccupancyRate'),
          },
          {
            //代理费
            type: 'amountNumber',
            label: this.$t('contractAgency.agencyFee'),
            prop: 'proxyExpense',
            moreInput: true,
            moreProp: 'proxyExpenseLocal',
            moreDisabled: true,
            required: true,
            placeholder: this.$t('contractAgency.inputTip') + this.$t('contractAgency.agencyFee'),
          },
          {
            //溢装比例
            type: 'amountNumber',
            label: this.$t('contractAgency.overShippedPercentage'),
            prop: 'overShippedPercentage',
            append: '%',
            required: true,
            precision: this.$globalVar.iPoint,
            max: 100,
            placeholder:
              this.$t('contractAgency.inputTip') + this.$t('contractAgency.overShippedPercentage'),
          },
          {
            //短装比例
            type: 'amountNumber',
            label: this.$t('contractAgency.shortShippedPercentage'),
            prop: 'shortShippedPercentage',
            append: '%',
            required: true,
            precision: this.$globalVar.iPoint,
            max: 100,
            placeholder:
              this.$t('contractAgency.inputTip') + this.$t('contractAgency.shortShippedPercentage'),
          },
          {
            //保证金比率
            type: 'amountNumber',
            label: this.$t('contractAgency.marginPercentage'),
            prop: 'marginPercentage',
            append: '%',
            precision: this.$globalVar.iPoint,
            max: 100,
            placeholder:
              this.$t('contractAgency.inputTip') + this.$t('contractAgency.marginPercentage'),
          },
          {
            //保证金
            type: 'amountNumber',
            label: this.$t('contractAgency.depositCash'),
            prop: 'marginAmount',
            moreInput: true,
            moreProp: 'marginAmountLocal',
            moreDisabled: true,
            required: true,
            placeholder: this.$t('contractAgency.inputTip') + this.$t('contractAgency.depositCash'),
          },
          {
            //进口国别
            type: 'input',
            label: this.$t('contractAgency.inportCountry'),
            prop: 'inportCountry',
          },
          {
            //原产地
            type: 'input',
            label: this.$t('contractAgency.originPlace'),
            prop: 'originPlace',
          },
          {
            //最晚收货日 (采购端)
            type: 'date',
            label: this.$t('contractAgency.lastestReceiveProductDay'),
            prop: 'lastestReceiveProductDay',
            required: true,
          },
          {
            //最晚付款日 (采购端)
            type: 'date',
            label: this.$t('contractAgency.lastestPayMoneyDay'),
            prop: 'lastestPayMoneyDay',
            required: true,
          },
          {
            //最晚发货日 (代理端)
            type: 'date',
            label: this.$t('contractAgency.lastestSendProductDay'),
            prop: 'lastestSendProductDay',
            required: true,
          },
          {
            //最晚收款日 (代理端)
            type: 'date',
            label: this.$t('contractAgency.lastestReceiveMoneyDay'),
            prop: 'lastestReceiveMoneyDay',
            required: true,
          },
          {
            //赊销
            prop: 'isCreditsale',
            label: this.$t('salePurchase.search.isCreditsale'),
            type: 'checkboxButton',
            moreBtn: true,
          },
          {
            //赊销金额
            type: 'amountNumber',
            label: this.$t('salePurchase.search.creditsaleAmount'),
            prop: 'creditAmount',
            disabled: !this.data.isCreditsale,
            required: this.data.isCreditsale,
            max: '99999999999.999999',
            placeholder:
              this.$t('contractAgency.inputTip') + this.$t('salePurchase.search.creditsaleAmount'),
          },
          {
            //预付
            prop: 'isPrepay',
            label: this.$t('salePurchase.search.isPrepay'),
            type: 'checkboxButton',
            moreBtn: true,
          },
          {
            //预付金额
            type: 'amountNumber',
            label: this.$t('salePurchase.search.prepayAmount'),
            prop: 'prepayAmount',
            disabled: !this.data.isPrepay,
            required: this.data.isPrepay,
            max: '99999999999.999999',
            placeholder:
              this.$t('contractAgency.inputTip') + this.$t('salePurchase.search.prepayAmount'),
          },
          // 投保
          {
            type: 'checkbox',
            label: this.$t('contractAgency.isInsure'),
            prop: 'isInsure',
          },
          {
            //不定价
            prop: 'isFixedPrice',
            label: this.$t('salePurchase.search.isSalesFixedPrice'),
            type: 'checkboxButton',
          },
          {
            //定价规则
            prop: 'pricingRule',
            label: this.$t('salePurchase.search.pricingRule'),
            type: 'ajaxSelect',
            apiUrl: BASE_API.DIC_CREDIT_API,
            apiData: { dictType: 'pricing_rule' },
            disabled: !this.data.isFixedPrice,
            required: this.data.isFixedPrice,
            valueType: 'string',
          },
          // 预计收款日期
          {
            type: 'date',
            label: this.$t('contractAgency.expectReceiptDay'),
            prop: 'expectReceiptDay',
          },
          // 业务订单
          {
            type: 'input',
            label: this.$t('contractAgency.businessId'),
            prop: 'businessId',
            disabled: true,
          },
          {
            //代理形式
            type: 'ajaxSelect',
            label: this.$t('contractAgency.proxyType'),
            prop: 'proxyType',
            apiUrl: AGENCY_API.DICT_LIST,
            apiData: { dictType: 'proxy_Type' },
            required: true,
            valueType: 'string',
            disabled:
              this.contractStatusList.indexOf(data.contractStatus) != -1 ? true : this.disabled,
          },
          {
            type: 'textarea',
            label: this.$t('contractAgency.mark'),
            prop: 'mark',
            span: 24,
            maxlength: 256,
          },
        ];
      },
    },
    watch: {
      defaultData() {
        this.initDepartment();
        this.initData();
      },

      'defaultData.contractCompanyNo': {
        handler(newValue, oldValue) {
          console.log(newValue, oldValue);
          if (newValue != oldValue && location.hash.indexOf('/add') != -1) {
            this.getLegerCode(newValue);
          }
        },
        deep: true,
      },
    },
    mounted() {
      // this.rules=this.options,
      // this.initData();
      // this.initDepartment();
    },
    methods: {
      //业务部门
      initDepartment() {
        if (!this.defaultData.contractCompanyNo) {
          return;
        }
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
          personCompanyCode: this.defaultData.contractCompanyNo,
        };
        this.$axios.post(BASE_API.GET_PERSON_API, params).then((res) => {
          if (0 == res.data.code) {
            this.contractDepartmentList = res.data.data.personDepartmentInfo;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      initData() {
        const amountData = {};
        this.amountProps.forEach((prop) => {
          if (this.defaultData[prop]) {
            amountData[prop] = spliceMoreZero(this.defaultData[prop]);
            amountData[prop + 'Local'] = spliceMoreZero(this.defaultData[prop + 'Local']);
          }
        });
        const purAmountData = {};
        this.purAmountProps.forEach((prop) => {
          if (this.defaultData[prop]) {
            purAmountData[prop] = spliceMoreZero(this.defaultData[prop]);
            purAmountData[prop + 'Local'] = spliceMoreZero(this.defaultData[prop + 'Local']);
          }
        });
        const data = Object.assign({}, this.data, this.defaultData, amountData, purAmountData, {
          isInsure: this.defaultData.isInsure === 0 ? false : true,
          isCreditsale: this.defaultData.isCreditsale == 0 ? false : true,
          isPrepay: this.defaultData.isPrepay == 0 ? false : true,
          isFixedPrice: this.defaultData.isFixedPrice == 0 ? false : true,
          entrustingPart:
            this.defaultData.entrustingPartName && this.defaultData.entrustingPartNo
              ? {}
              : undefined,
          partner: this.defaultData.partnerName && this.defaultData.partnerNo ? {} : undefined,
          customer: this.defaultData.customerName && this.defaultData.customerNo ? {} : undefined,
        });
        delete data.attachmentList;
        delete data.orderTradeDetailList;
        delete data.orderInterest;
        delete data.orderDelivery;
        delete data.orderContractRelationshipList;
        this.data = data;
      },
      // 获取本币名称
      async getLegerCode(companyCode) {
        if (companyCode) {
          let res = await this.$axios.get(AGENCY_API.GET_LEGER_CODE_NAME, { companyCode });
          if (res) {
            if (res.data.code == 0) {
              let data = res.data.data;
              if (data.currencyCode) {
                //公司---本币
                if (!this.data.companyCurrency) {
                  this.data.salesCurrencyCode = data.currencyCode;
                  this.data.salesCurrencyName = data.currencyName;
                  this.data.purchaseCurrencyCode = data.currencyCode;
                  this.data.purchaseCurrencyName = data.currencyName;
                  //历史
                  this.data.historyCurrencyName = data.currencyName;
                  this.data.historyCurrencyCode1 = data.currencyCode;
                  this.data.historyCurrencyCode2 = data.currencyCode;
                }
                this.data.companyCurrency = data.currencyCode;
                this.data.companyCurrencyName = data.currencyName;
              }
            }
          }
        }
      },
      // 表单变化
      handleChange(value, prop) {
        //业务部门
        if (prop == 'contractDepartmentNo') {
          if (this.data.contractDepartmentNo) {
            this.data.contractDepartmentName = this.contractDepartmentList.find((item) => {
              return item.personDepartmentCode == this.data.contractDepartmentNo;
            }).personDepartmentName;
          }
          this.data.supplier = null;
          this.data.partnerNo = null;
          this.data.partnerName = null;
          this.data.entrustingPartNo = null;
          this.data.entrustingPartName = null;
          this.data.entrustingPart = null;
          this.data.customerNo = null;
          this.data.customerName = null;
        }
        //业务性质
        if (prop == 'businessType') {
          this.$emit('changeBusinessType', value[prop]);
        }
        // 保证金等于保证金比率*销售费用
        if (prop == 'marginPercentage' || prop == 'salesExpense') {
          if (value.marginPercentage && value.salesExpense) {
            const params = {
              returnQuantity: value.salesExpense,
              returnUnitPrice: value.marginPercentage / 100,
            };
            this.$axios
              .post(AGENCY_API.GET_RETURN_MONEY_AMOUNT, params)
              .then((res) => {
                if (0 == res.data.code) {
                  this.data.marginAmount = res.data.data.returnMoneyAmount;
                }
              })
              .then(() => {
                // prop = 'marginAmount';
                let arr = ['marginAmount', 'salesExpense']; //保证金  销售费用
                arr.forEach((item) => {
                  // 需要计算本币   销售相关用销售汇率
                  calAmount(this.data[item], this.data.salesCurrencyExchangeRate).then(
                    (showLocal) => {
                      this.data[item + 'Local'] = showLocal;
                    }
                  );
                });
              });
          }
          if (!value.marginPercentage || !value.salesExpense) {
            this.data.marginAmount = '';
            this.data.marginAmountLocal = '';
          } else if (!value.marginAmount) {
            this.data.marginAmountLocal = '';
          }
        }
        // 销售相关用销售汇率  salesCurrencyExchangeRate
        const index = this.amountProps.indexOf(prop);
        if (index > -1 && this.data.salesCurrencyExchangeRate) {
          // 需要计算本币
          calAmount(this.data[prop], this.data.salesCurrencyExchangeRate).then((showLocal) => {
            if (showLocal) {
              this.data[prop + 'Local'] = showLocal;
            } else {
              this.data[prop + 'Local'] = '';
            }
          });
        }
        // 采购相关用采购汇率  contractCurrencyExchangeRate
        const indexPur = this.purAmountProps.indexOf(prop);
        if (indexPur > -1 && this.data.contractCurrencyExchangeRate) {
          // 需要计算本币
          calAmount(this.data[prop], this.data.contractCurrencyExchangeRate).then((showLocal) => {
            if (showLocal) {
              this.data[prop + 'Local'] = showLocal;
            } else {
              this.data[prop + 'Local'] = '';
            }
          });
        }
        // 委托方变化：生成销售货币种类
        if (prop == 'entrustingPart') {
          // 委托方类型
          this.data.entrustingPartType = value.entrustingPart[0].partnerForm || null;
          const tradeCurrency1 = value.entrustingPart[0].tradeCurrency;
          const salesCurrencyCode = this.data.salesCurrencyCode;
          if (tradeCurrency1 && tradeCurrency1 != salesCurrencyCode) {
            this.data = Object.assign({}, this.data, {
              salesCurrencyCode: tradeCurrency1,
              salesCurrencyName: '',
            });
            this.changeCurrency('saleCurrencyCode');
          }
        }
        // 供应商变化：生成采购货币种类
        if (prop == 'partner') {
          // 供应商类型
          this.data.partnerType = value.partner[0].partnerForm || null;
          const tradeCurrency2 = value.partner[0].tradeCurrency;
          const purchaseCurrencyCode = this.data.purchaseCurrencyCode;
          if (tradeCurrency2 && tradeCurrency2 != purchaseCurrencyCode) {
            this.data = Object.assign({}, this.data, {
              purchaseCurrencyCode: tradeCurrency2,
              purchaseCurrencyName: '',
            });
            this.changeCurrency('purchaseCurrencyCode');
          }
        }
        // 客户变化
        if (prop == 'customer') {
          // 客户类型
          this.data.customerType = value.customer[0].partnerForm || null;
        }
        // 货币变化，重新获取汇率 -> 重新计算本币
        // const rateProp = ['settleCurrency', 'purchaseCurrencyCode', 'salesCurrencyCode'];
        const rateProp = ['purchaseCurrencyCode', 'salesCurrencyCode'];
        if (rateProp.indexOf(prop) > -1) {
          this.changeCurrency(prop);
        }
        // 结算货币变化
        if (prop == 'settleCurrency') {
          this.$emit(
            'settleRate',
            this.data.settleCurrency == 1
              ? this.data.salesCurrencyExchangeRate
              : this.data.contractCurrencyExchangeRate
          );
        }
        // 溢装比例改变，短装比例与其一致
        if (prop == 'overShippedPercentage') {
          if (!this.flag) {
            this.data.shortShippedPercentage = this.data.overShippedPercentage;
          }
        }
        if (prop == 'shortShippedPercentage') {
          var val = this.data.shortShippedPercentage;
          var notNull = !val && typeof val != 'undefined';
          if (!notNull) {
            this.flag = true;
          } else {
            this.flag = false;
          }
        }
        // 最晚收货日，运输信息中最迟收获日与这个一致
        if (prop === 'lastestReceiveProductDay') {
          this.$emit('latestDate', this.data.lastestReceiveProductDay);
        }
        //预付发生辩护
        if (prop == 'isPrepay') {
          this.data.prepayAmount = null;
          this.$nextTick(() => {
            this.$refs.baseForm.clear('prepayAmount');
          });
        }
        //赊销发生变化
        if (prop == 'isCreditsale') {
          this.data.creditAmount = null;
          this.$nextTick(() => {
            this.$refs.baseForm.clear('creditAmount');
          });
        }
        // 代理不定价发生变化
        if (prop == 'isFixedPrice') {
          this.data.pricingRule = null;
          this.$nextTick(() => {
            this.$refs.baseForm.clear('pricingRule');
          });
        }
        if (prop == 'isCreditsalebutton') {
          if (!value.entrustingPartNo) {
            this.$message({
              showClose: true,
              message: '请选择委托方',
              type: 'error',
            });
            return;
          } else {
            let path = {
              path: '/credit/statisticsList',
              name: 'creditStatisticsList',
              meta: {
                keepAlive: true,
                title: '信用额度统计',
              },
              query: {
                partnerCode: value.entrustingPartNo,
                validDate: dateFormatter(new Date()),
              },
            };
            this.$store.dispatch('tagsView/addTabView', path).then(() => {
              this.$nextTick(() => {
                this.$router.push(path);
              });
            });
          }
        }
        if (prop == 'isPrepaybutton') {
          if (!value.partnerNo) {
            this.$message({
              showClose: true,
              message: '请选择供应商',
              type: 'error',
            });
            return;
          } else {
            let path = {
              path: '/credit/statisticsList',
              name: 'creditStatisticsList',
              meta: {
                keepAlive: true,
                title: '信用额度统计',
              },
              query: {
                partnerCode: value.partnerNo,
                validDate: dateFormatter(new Date()),
              },
            };
            this.$store.dispatch('tagsView/addTabView', path).then(() => {
              this.$nextTick(() => {
                this.$router.push(path);
              });
            });
          }
        }
      },
      changeCurrency(prop) {
        const currencyCode =
          prop == 'purchaseCurrencyCode'
            ? this.data.purchaseCurrencyCode
            : this.data.salesCurrencyCode;
        this.$forceUpdate();
        if (currencyCode) {
          this.getRate(prop);
        }
      },
      // 更新本币计算
      updateAmount() {
        Object.keys(this.data).forEach((prop) => {
          //销售汇率
          if (this.amountProps.indexOf(prop) > -1 && this.data[prop]) {
            calAmount(this.data[prop], this.data.salesCurrencyExchangeRate).then((showLocal) => {
              this.data[prop + 'Local'] = showLocal;
            });
          }
          if (this.purAmountProps.indexOf(prop) > -1 && this.data[prop]) {
            //采购汇率
            calAmount(this.data[prop], this.data.contractCurrencyExchangeRate).then((showLocal) => {
              this.data[prop + 'Local'] = showLocal;
            });
          }
        });
      },
      // 获取汇率
      getRate(prop) {
        if (this.initFlag && this.params.contractCurrencyExchangeRate) return;
        const data = this.data;
        const fromCurrencyCode =
          prop == 'purchaseCurrencyCode' ? data.purchaseCurrencyCode : data.salesCurrencyCode;
        const toCurrencyCode = data.companyCurrency; //公司  本币
        //如果没有本位币
        if (data.contractCompanyNo == 'C0328') {
          if (prop == 'purchaseCurrencyCode') {
            this.data.historyCurrencyCode2 = '';
            this.data.purchaseCurrencyCode = '';
          } else {
            this.data.historyCurrencyCode1 = '';
            this.data.salesCurrencyCode = '';
          }
          this.$message({
            showClose: true,
            message: '请先配置公司帐套',
            type: 'error',
          });
          return;
        }
        if (fromCurrencyCode === data.companyCurrency) {
          //为本币时汇率为1
          prop == 'purchaseCurrencyCode'
            ? (this.data.contractCurrencyExchangeRate = 1)
            : (this.data.salesCurrencyExchangeRate = 1);
          prop == 'purchaseCurrencyCode'
            ? (this.data.historyCurrencyCode2 = fromCurrencyCode)
            : (this.data.historyCurrencyCode1 = fromCurrencyCode);
          this.$emit(
            'rateChange',
            prop == 'purchaseCurrencyCode'
              ? { purchaseCurrencyCode: this.data.contractCurrencyExchangeRate }
              : { saleCurrencyCode: this.data.salesCurrencyExchangeRate }
          );
          this.$emit(
            'settleRate',
            this.data.settleCurrency == 1
              ? this.data.salesCurrencyExchangeRate
              : this.data.contractCurrencyExchangeRate
          ); //结算货币汇率
          this.updateAmount();
          return;
        }
        if (!toCurrencyCode) {
          return;
        }
        this.$axios
          .post(AGENCY_API.GET_CURRENCY_EXCHANGE, {
            fromCurrencyCode,
            toCurrencyCode,
            exchangeDate: this.$baseRequest.getBeginOfMonth(new Date()),
            exchangeType: 'Cooperate',
          })
          .then((res) => {
            if (res.data.data) {
              prop == 'purchaseCurrencyCode'
                ? (this.data.contractCurrencyExchangeRate = res.data.data.positiveRate)
                : (this.data.salesCurrencyExchangeRate = res.data.data.positiveRate);
              prop == 'purchaseCurrencyCode'
                ? (this.data.historyCurrencyCode2 = fromCurrencyCode)
                : (this.data.historyCurrencyCode1 = fromCurrencyCode);
              this.$emit(
                'rateChange',
                prop == 'purchaseCurrencyCode'
                  ? { purchaseCurrencyCode: this.data.contractCurrencyExchangeRate }
                  : { saleCurrencyCode: this.data.salesCurrencyExchangeRate }
              );
              this.$emit(
                'settleRate',
                this.data.settleCurrency == 1
                  ? this.data.salesCurrencyExchangeRate
                  : this.data.contractCurrencyExchangeRate
              ); //结算货币汇率
              this.updateAmount();
            } else {
              // 没获取到汇率，选择默认人民币
              prop == 'purchaseCurrencyCode'
                ? (this.data.contractCurrencyExchangeRate = 1)
                : (this.data.salesCurrencyExchangeRate = 1);
              this.$emit(
                'rateChange',
                prop == 'purchaseCurrencyCode'
                  ? { purchaseCurrencyCode: this.data.contractCurrencyExchangeRate }
                  : { saleCurrencyCode: this.data.salesCurrencyExchangeRate }
              );
              this.$emit(
                'settleRate',
                this.data.settleCurrency == 1
                  ? this.data.salesCurrencyExchangeRate
                  : this.data.contractCurrencyExchangeRate
              ); //结算货币汇率
              this.$alert(res.data.msg);
              prop == 'purchaseCurrencyCode'
                ? (data.purchaseCurrencyCode = this.data.historyCurrencyCode2)
                : (data.salesCurrencyCode = this.data.historyCurrencyCode1);
              this.data = data;
            }
          });
      },
      // 获取表单的值
      getValues() {
        const data = this.data;
        // const userInfo = this.userInfo;
        const result = Object.assign({}, data, {
          isInsure: data.isInsure ? 1 : 0,
          isCreditsale: data.isCreditsale ? 1 : 0,
          isPrepay: data.isPrepay ? 1 : 0,
          isFixedPrice: data.isFixedPrice ? 1 : 0,
        });
        delete result.entrustingPart;
        delete result.partner;
        delete result.customer;
        this.amountProps.forEach((prop) => {
          if (!result[prop]) {
            result[prop] = 0;
          }
        });
        this.purAmountProps.forEach((prop) => {
          if (!result[prop]) {
            result[prop] = 0;
          }
        });
        return result;
      },
      handleSubmit() {
        return this.$refs['baseForm'].handleSubmit();
      },
    },
  };
</script>
<style lang="scss">
  .labelLong {
    .el-form-item__label {
      line-height: 16px;
    }
  }
  .base-more-input,
  .my-el-input {
    .el-input-group__prepend {
      padding: 0 5px;
    }
  }
  .my-el-input {
    .el-input-group__append {
      padding: 0 10px;
    }
  }
</style>
